import CheckIcon from '@mui/icons-material/CheckCircle'
import IconButton from '@mui/material/IconButton'
import classnames from 'classnames'
import React from 'react'
import { Mutation } from 'react-apollo'
import { shouldContinuingItemNameBeHighlighted } from '../../common/utils'
import { i18n } from '../index'
import css from './Checklist.css'
import buttonCss from './ChecklistButton.css'
import { fetchDailyChecklist, markContinuingChecklistItemChecked } from './checklistQueries'

const ContinuingChecklistTaskRow = ({ item, stationId, date }) => {
  const checkItem = (onMutate: (...args: Array<any>) => any, id: number) => {
    onMutate({
      variables: {
        stationId,
        continuingChecklistItemId: id,
        date,
      },
    })
  }

  return (
    <Mutation
      mutation={markContinuingChecklistItemChecked}
      refetchQueries={[
        {
          query: fetchDailyChecklist,
          variables: {
            stationId,
            date,
          },
        },
      ]}
    >
      {(onMutate) => (
        <tr>
          <td
            className={classnames(css.taskName, {
              [css.highlightedTask]: shouldContinuingItemNameBeHighlighted(item),
            })}
          >
            {item.description}
          </td>
          <td className={css.taskName}>
            {item.type
              ? item.type.map((t) => i18n.t(`checkList.type.${t}`)).join(', ')
              : i18n.t('checkList.type.NotDefined')}
          </td>
          <td className={css.checkCell}>
            {item.interval === 'Daily' && (
              <IconButton
                className={classnames(buttonCss.button, buttonCss.notChecked)}
                onClick={() => checkItem(onMutate, item.id)}
                disabled={item.interval !== 'Daily'}
              >
                <CheckIcon />
              </IconButton>
            )}
          </td>
          <td className={css.checkCell}>
            {item.interval === 'Weekly' && (
              <IconButton
                className={classnames(buttonCss.button, buttonCss.notChecked)}
                onClick={() => checkItem(onMutate, item.id)}
                disabled={item.interval !== 'Weekly'}
              >
                <CheckIcon />
              </IconButton>
            )}
          </td>
          <td className={css.checkCell}>
            {item.interval === 'Monthly' && (
              <IconButton
                className={classnames(buttonCss.button, buttonCss.notChecked)}
                onClick={() => checkItem(onMutate, item.id)}
                disabled={item.interval !== 'Monthly'}
              >
                <CheckIcon />
              </IconButton>
            )}
          </td>
        </tr>
      )}
    </Mutation>
  )
}

export default ContinuingChecklistTaskRow
